export default __webpack_public_path__ + "static/media/ms-homepage-desktop.0d203c30.jpg";